import { Box } from "@mui/material"
import React from "react"

interface WrapContainerProps {
  children: React.ReactNode
  imgSrc: string
  imgAlt: string
}

const WrapContainer = ({ children, imgSrc, imgAlt }: WrapContainerProps) => {
  return (
    <Box
      sx={theme => ({
        border: "solid 4px #1FA009",
        bgcolor: "#fff",
        borderRadius: "16px",
        position: "relative",
        [theme.breakpoints.down(600)]: {
          paddingBottom: 3,
        },
      })}
    >
      <Box
        top="-40px"
        width="100%"
        sx={theme => ({
          zIndex: 999,
          textAlign: "center",
          "& > img": {
            [theme.breakpoints.down(450)]: {
              width: "80%",
            },
          },
        })}
        position="absolute"
      >
        <img src={imgSrc} alt={imgAlt} />
      </Box>
      <Box
        sx={theme => ({
          padding: "48px 24px",
          display: "flex",
          flexDirection: "column",
          rowGap: "16px",
          columnGap: "24px",
          fontFamily: "Roboto Slab",
          overflowY: "auto",
          maxHeight: 500,
          [theme.breakpoints.down(600)]: {
            maxHeight: 350,
            padding: "32px 16px 24px",
          },
        })}
      >
        {children}
      </Box>
    </Box>
  )
}

export default WrapContainer
